enum TransferCreditType {
    Hours = "hours",
    Practical = "practical",
    Credits = "credits",
    Grade = "grade",
    TheoryHours = "theory_hours"
}

type ParamsGetListTransferCredits = {
    studentProfileId: number
    range?: {
        page: number
        pageSize: number
    }
    filter?: {
        text?: string
    }
}
enum ApprovalStatus {
    PENDING = "pending",
    APPROVED = "approved",
    REJECTED = "rejected"
}
type TransferCredits = {
    id?: number
    idTransfer?: number | string
    type?: TransferCreditType | null
    termNameTransfer?: string
    courseNameTransfer?: string
    nameForTranscript?: string
    codeForTranscript?: string
    studentProfileId?: number
    universityId?: number
    creditsTransfer?: number
    qualityPoints?: number
    grades?: number
    alphabetical?: string
    gradeEquivalent?: string | null
    idEquivalent?: number
    equivalentProgramId?: number | null
    codeEquivalent?: string
    programCodeEquivalent?: string
    programNameEquivalent?: string
    creditsEquivalent?: number
    appliedCredits?: number
    approvalStatus?: ApprovalStatus
    termName?: string
    approvalSignatureId?: number
    approvalStatusUpdatedAt?: string
    universityName?: string
    programNameTransfer?: string
    courseName?: string
    createdAt?: string
    updatedAt?: string
    deletedAt?: string
}

type ResponseListTransferCredits = {
    data: TransferCredits[]
    total: number
}

type ParamCreateTransferCredits = {
    listTransferCredits: TransferCredits[]
}
interface ParamUpdateTransferCredits extends TransferCredits {}

export type {
    ParamsGetListTransferCredits,
    ResponseListTransferCredits,
    ParamCreateTransferCredits,
    TransferCredits,
    ParamUpdateTransferCredits
}

export {TransferCreditType, ApprovalStatus}
